export const GET_NEW_ARRIVALS = 'GET_NEW_ARRIVALS';